import { GridRowEditStartedEventArgs as GridRowEditStartedEventArgs_internal } from "./GridRowEditStartedEventArgs";
var IgrGridRowEditStartedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridRowEditStartedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridRowEditStartedEventArgs.prototype.createImplementation = function () {
        return new GridRowEditStartedEventArgs_internal();
    };
    Object.defineProperty(IgrGridRowEditStartedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridRowEditStartedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridRowEditStartedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridRowEditStartedEventArgs.prototype, "row", {
        /**
         * Gets the row that started editing.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridRowEditStartedEventArgs.prototype, "item", {
        /**
         * Gets the row item.
        */
        get: function () {
            return this.i.item;
        },
        set: function (v) {
            this.i.item = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridRowEditStartedEventArgs;
}());
export { IgrGridRowEditStartedEventArgs };
//# sourceMappingURL=igr-grid-row-edit-started-event-args.js.map
